import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CartPanelComponent } from "./cart-panel/cart-panel.component";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material/button";
import { MatBadgeModule } from "@angular/material/badge";

import { SvgIconModule } from "@dodo/svg-icon/svg-icon.module";
import { RouterModule } from "@angular/router";
import { DodoDirectives } from "@dodo/directives/directives.module";
import { TotalValueDisplayComponent } from "./total-value-display/total-value-display.component";
import { DodoMatComponentsCommonModule } from "_libs/dodo-mat-components/dodo-mat-components-common.module";
import { CartItemGroupComponent } from "./cart-item-group/cart-item-group.component";

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		MatCardModule,
		SvgIconModule,
		MatButtonModule,
		MatBadgeModule,
		MatSidenavModule,
		DodoDirectives,
		DodoMatComponentsCommonModule,
	],
	declarations: [
		CartPanelComponent,
		TotalValueDisplayComponent,
		CartItemGroupComponent,
	],
	exports: [
		CartPanelComponent,
	],
})
export class ShoppingCartModule {}
